// extracted by mini-css-extract-plugin
export var bounce = "SlideMenu-module--bounce--cc69b";
export var dotMoveLeft = "SlideMenu-module--dot-move-left--29cac";
export var dotMoveRight = "SlideMenu-module--dot-move-right--c15c9";
export var gradient = "SlideMenu-module--gradient--0d80b";
export var separatorWidth = "SlideMenu-module--separator-width--09a36";
export var slideDown = "SlideMenu-module--slideDown--f069b";
export var wrapper = "SlideMenu-module--wrapper--3da04";